import React from 'react';
import PropTypes from 'prop-types';

/**
 * Error Boundary component for ScrollWrapper
 * Provides fallback UI when ScrollSmoother fails
 */
class ScrollWrapperErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true, error };
	}

	componentDidCatch(error, errorInfo) {
		console.error('ScrollWrapper Error:', error, errorInfo);
	}

	render() {
		if (this.state.hasError) {
			// Fallback UI - render children without smooth scrolling
			return (
				<div id='smooth-wrapper'>
					<div id='smooth-content'>{this.props.children}</div>
				</div>
			);
		}

		return this.props.children;
	}
}

ScrollWrapperErrorBoundary.propTypes = {
	children: PropTypes.node.isRequired,
};

export default ScrollWrapperErrorBoundary;
